import React from "react";

const TestimonialSlide = () => {
	return (
		<div className="grid grid-cols-2 mobiles:grid-cols-5 gap-12 h-70vh mobiles:h-60vh text-left">
			<img
				src={require("../../assets/Imagetest.svg").default}
				className="w-full mobiles:col-span-2"
				alt=""
			/>
			<div className="pt-36 mobiles:pt-10 mobiles:col-span-3">
				<img
					src={require("../../assets/quote.svg").default}
					className="w-10 block"
					alt=""
				/>
				<h4 className="mt-10 text-2xl mobiles:text-lg sabi-header text-white">
					I am using it for my upcoming wedding in December of 2021! I love that it brings
					gifts from everywhere into one location
				</h4>

				<p className="mt-24 mobiles:mt-12 text-white text-2xl">...Nash & Pam</p>
			</div>
		</div>
	);
};

export default TestimonialSlide;
